import type { RawButtonProps } from '@ps/web-shared-components';
import { RawButton, Translation, useTrackingLabel } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { PlayType } from '@swf/core/types/CasinoGame';

import { TXTMOB_Single_Player, TXTWCL_Multiplayer } from './PlayButton.messages.json';
import styles from './PlayButton.scss';

export interface Props {
  playType: PlayType;
  size?: RawButtonProps['size'];
  className?: string;
  onClick(playType: PlayType, label?: string): void;
}

const PlayButton: React.FC<Props> = ({ className, onClick, size, playType }) => {
  const isMobile = useSelector(select.device.isMobile);
  const translation = playType === PlayType.Single ? TXTMOB_Single_Player : TXTWCL_Multiplayer;
  const label = useTrackingLabel(translation);

  const gameTypeSelection = [
    playType === PlayType.Single ? styles.single : styles.multi,
    styles.desktop
  ];

  return (
    <RawButton
      className={classNames(
        styles.button,
        size && styles[size as keyof typeof styles],
        className,
        !isMobile && gameTypeSelection
      )}
      onClick={() => onClick(playType, label)}
      size={size}
    >
      <Translation {...translation} />
    </RawButton>
  );
};

export default PlayButton;
